var uh;
(function (uh) {
    class App extends Phaser.Game {
        constructor() {
            let config = {
                type: Phaser.AUTO,
                width: "100%",
                height: "100%",
                backgroundColor: 0xFF0000,
                parent: 'game-container',
                dom: {
                    createContainer: true
                },
                scale: {
                    mode: Phaser.Scale.RESIZE,
                    autoCenter: Phaser.Scale.NO_CENTER
                },
                transparent: false,
                scene: {
                    create: () => {
                        this.scene.add('Boot', uh.scene.Boot, true);
                    }
                }
            };
            super(config);
        }
    }
    App.ART_SCALE = 0.6;
    uh.App = App;
})(uh || (uh = {}));
let game;
window.onload = () => {
    game = new uh.App();
};
/**
 * @author Roman Parada
 * This class is created to fix overlapping of bottom part of canvas by navigation bar in iOS.
 * It make a delayed resize of the canvas (like Phaser-3 FIT methods does) and it overrides Phaser-3 input window to Phaser-3 core transform methods
 *
 * How to use:
 * Just call the code line below in Boot scene's init() method of your project:
 * new FitScaleManager(this.game).setup();
 */
class FitScaleManager {
    constructor(game) {
        this.doResize = () => {
            let scale = this.calculateScale();
            let newCanvasWidth = this.phaserScaleManager.width * scale;
            let newCanvasHeight = this.phaserScaleManager.height * scale;
            this.canvasStyle.width = newCanvasWidth + 'px';
            this.canvasStyle.height = newCanvasHeight + 'px';
            this.canvasStyle.marginLeft = (window.innerWidth - newCanvasWidth) / 2 + 'px';
            this.canvasStyle.marginTop = (window.innerHeight - newCanvasHeight) / 2 + 'px';
        };
        this.game = game;
        this.canvasStyle = this.game.canvas.style;
        this.phaserScaleManager = this.game.scale;
    }
    /**
     * Just call this method once in Boot scene's init() method
     */
    setup() {
        this.phaserScaleManager.addListener(Phaser.Scale.Events.RESIZE, this.onResize, this);
        this.overridePhaserTransformMethods();
        this.onResize();
    }
    calculateScale() {
        return Math.min(window.innerWidth / this.phaserScaleManager.width, window.innerHeight / this.phaserScaleManager.height);
    }
    overridePhaserTransformMethods() {
        this.game.scale.transformX = (pageX) => {
            return (pageX - parseInt(this.canvasStyle.marginLeft.split("px")[0])) / this.calculateScale();
        };
        this.game.scale.transformY = (pageY) => {
            return (pageY - parseInt(this.canvasStyle.marginTop.split("px")[0])) / this.calculateScale();
        };
    }
    onResize() {
        setTimeout(this.doResize, FitScaleManager.RESIZE_DELAY);
    }
}
FitScaleManager.RESIZE_DELAY = 500;
var uh;
(function (uh) {
    var input;
    (function (input) {
        class InputController {
            constructor(scene) {
                this._keyLeftPressUsed = false;
                this._keyRightPressUsed = false;
                this.scene = scene;
                this.cursorKeys = this.scene.input.keyboard.createCursorKeys();
                this.cursorKeys.left.on('up', () => { this.cursorKeys.left['-used-'] = false; });
                this.cursorKeys.left['-used-'] = false;
                this.cursorKeys.right.on('up', () => { this.cursorKeys.right['-used-'] = false; });
                this.cursorKeys.right['-used-'] = false;
                this.scene.input.on("pointerup", () => {
                    this._keyRightPressUsed = false;
                    this._keyLeftPressUsed = false;
                });
                this.scene.input.keyboard.removeCapture([Phaser.Input.Keyboard.KeyCodes.LEFT, Phaser.Input.Keyboard.KeyCodes.RIGHT]);
            }
            isLeftPressed() {
                return this.scene.game.input.touch && this.scene.game.input.touch.enabled && this.scene.input.activePointer.isDown && this.scene.input.activePointer.x < this.scene.scale.width / 2
                    || this.cursorKeys.left.isDown;
            }
            isRightPressed() {
                return this.scene.game.input.touch && this.scene.game.input.touch.enabled && this.scene.input.activePointer.isDown && this.scene.input.activePointer.x > this.scene.scale.width / 2
                    || this.cursorKeys.right.isDown;
            }
            keyLeftPressedDownAndReleased() {
                return this.cursorKeys.left.isDown && !this.cursorKeys.left['-used-']
                    || this.isLeftPressed() && !this._keyLeftPressUsed;
            }
            keyLeftPressUsed() {
                this.cursorKeys.left['-used-'] = true;
                this._keyLeftPressUsed = true;
            }
            keyRightPressedDownAndReleased() {
                return this.cursorKeys.right.isDown && !this.cursorKeys.right['-used-']
                    || this.isRightPressed() && !this._keyRightPressUsed;
            }
            keyRightPressUsed() {
                this.cursorKeys.right['-used-'] = true;
                this._keyRightPressUsed = true;
            }
        }
        input.InputController = InputController;
    })(input = uh.input || (uh.input = {}));
})(uh || (uh = {}));
var uh;
(function (uh) {
    var scene;
    (function (scene) {
        class Boot extends Phaser.Scene {
            init() {
                // game.input.mouse.enabled = !game.device.input.touch;
                new FitScaleManager(this.game).setup();
            }
            create() {
                game.scene.remove('Boot');
                game.scene.add('Preloader', uh.scene.Preloader, true);
            }
        }
        scene.Boot = Boot;
    })(scene = uh.scene || (uh.scene = {}));
})(uh || (uh = {}));
var uh;
(function (uh) {
    var scene;
    (function (scene) {
        class Preloader extends Phaser.Scene {
            preload() {
                for (let f of window["customFontFamilies"]) {
                    this.add.text(-100, -100, "v1", {
                        "fontFamily": f,
                        "fontSize": 14,
                        "color": "#FFFFFF",
                        "align": 'center'
                    });
                }
            }
            create() {
                let p = new Phaser.GameObjects.Container(this);
                this.children.add(p);
                let txt = this.add.text(Math.floor(this.scale.width / 2), Math.floor(this.scale.height / 2), "0%", {
                    "fontFamily": 'Lo-Res',
                    "fontSize": 50,
                    "color": "#FFFFFF",
                    "align": 'center'
                });
                txt.setOrigin(0.5, 0.5);
                p.add(txt);
                this.load.pack('preloader', 'assets/pack.json');
                this.load.on('progress', (value) => {
                    txt.setText(Math.ceil(value * 100) + "%");
                }, this);
                this.load.on('complete', () => {
                    this.nextScene();
                });
                this.load.start();
            }
            nextScene() {
                game.scene.remove('Preloader');
                game.scene.add('ScreenMain', uh.scene.ScreenMain, true);
            }
        }
        scene.Preloader = Preloader;
    })(scene = uh.scene || (uh.scene = {}));
})(uh || (uh = {}));
var uh;
(function (uh) {
    var scene;
    (function (scene) {
        class ScreenMain extends Phaser.Scene {
            constructor() {
                super(...arguments);
                this.obstaclesBlocks = {
                    2: [0, 2],
                    5: [2, 4],
                    7: [1, 3],
                    9: [0, 1, 2],
                    10: [2, 3, 4],
                    11: [0, 1, 4],
                    12: [0, 3, 4]
                };
                this.totalCarLines = 5;
                this.carLineWidth = 182 * uh.App.ART_SCALE;
                this.maxDefCarSpeed = 38 * uh.App.ART_SCALE;
                this.carSpeedImpulseByPowerUp = 1.07;
                this.carAccelerationFactor = 150;
                this.baseBGImageWidth = 960 * uh.App.ART_SCALE;
                this.baseBGImageHeight = 1920 * uh.App.ART_SCALE;
                this.carLineIndex = 2;
                this.maxCarSpeed = this.maxDefCarSpeed;
                this.carSpeed = 0;
                this.scaleFactor = 1;
                this.scaleFactorCorrectedBySpeed = undefined;
                this.targetScaleFactorCorrectedBySpeed = 1;
                this.obstacles = [];
                this.powerups = [];
                this.isIngameShown = false;
                this.onTryAgainClicked = () => {
                    this.isIngameShown = false;
                    this.ui.hideTimesUp();
                    this.showIngameScreen();
                    uh.sound.SoundManager.getInstance().playSound('click', 1);
                    uh.sound.SoundManager.getInstance().playSound('Sports-Car-Idle', 1, true);
                    uh.sound.SoundManager.getInstance().playMusic('Action Sport Loop 01', true, 0.2);
                };
                //TIMER
                this.timerEvent = null;
                this.timeLeft = 35;
                this.timeAlert = 5;
                this.startTimerCountdown = () => {
                    this.restartTimer();
                    this.isActivated = true;
                };
                this.isCarSwitchingLine = false;
                this.isCrashed = false;
                this.isActivated = false;
                this.ticker = 35;
                this.powerupsSpawner = null;
                this.isPowerUpSpawnAllowed = true;
                this.obstacleIDs = [2, 5, 7, 9, 10, 11, 12];
            }
            createAnims() {
                this.anims.create({
                    key: "car_hit_playing",
                    frames: this.anims.generateFrameNames("texture-atlas", {
                        start: 0, end: 21, zeroPad: 4,
                        prefix: "car_hit", suffix: ''
                    }),
                    frameRate: 24,
                    repeat: 0
                });
                this.anims.create({
                    key: "car_powerup_playing",
                    frames: this.anims.generateFrameNames("texture-atlas", {
                        start: 0, end: 8, zeroPad: 4,
                        prefix: "car_powerup", suffix: ''
                    }),
                    frameRate: 15,
                    repeat: 0
                });
            }
            create() {
                this.calculateScaleFactor();
                this.inputController = new uh.input.InputController(this);
                this.createAnims();
                this.ui = new uh.ui.UI(this);
                this.children.add(this.ui);
                this.ui.setDepth(5);
                this.showTitleScreen();
                this.resizeUI();
                window["screenMain"] = this;
            }
            showTitleScreen() {
                this.ui.showTitleScreen();
                this.input.once('pointerdown', () => {
                    this.ui.hideTitleScreen();
                    this.showIngameScreen();
                    this.createIngameObjects();
                    uh.sound.SoundManager.getInstance().playSound('click', 1);
                    uh.sound.SoundManager.getInstance().playSound('V6_Camaro-2', 0.4);
                    uh.sound.SoundManager.getInstance().playSound('Sports-Car-Idle', 1, true);
                    uh.sound.SoundManager.getInstance().playMusic('Action Sport Loop 01', true, 0.2);
                });
            }
            resetData() {
                for (let obs of this.obstacles) {
                    obs.destroy(true);
                }
                this.obstacles = [];
                for (let pow of this.powerups) {
                    this.tweens.killTweensOf(pow);
                    pow.destroy(true);
                }
                this.powerups = [];
                this.carLineIndex = 2;
                this.isIngameShown = true;
                this.isCarSwitchingLine = false;
                this.maxCarSpeed = this.maxDefCarSpeed;
                this.carSpeed = 0;
                this.distance = 0;
                this.powerUpsCollected = 0;
                this.score = 0;
                this.ui.setDistance(this.distance);
                this.ui.setPowerUps(this.powerUpsCollected);
                this.calculateScore();
                this.timeLeft = 35;
                this.ui.setTime(this.timeLeft);
                this.ui.setBest(uh.storage.LocalStorageController.instance.getBest());
            }
            showIngameScreen() {
                this.resetData();
                this.ui.showIcon321(this.startTimerCountdown);
            }
            createIngameObjects() {
                this.ingameContainer = this.add.container(0, 0);
                this.ingameContainer.setDepth(4);
                this.bgContainer = this.add.container(this.scale.width / 2, 0);
                this.bgContainer.setDepth(0);
                this.ingameContainer.add(this.bgContainer);
                this.fillBgContainer();
                this.car = this.add.sprite(0, 0, 'texture-atlas', 'car' + '0000');
                this.car.setOrigin(0.5, 0);
                this.car.setDepth(3);
                this.ingameContainer.add(this.car);
                this.resize();
            }
            fillBgContainer() {
                let requiredBgsNum = Math.ceil(this.game.scale.height / (this.baseBGImageHeight * this.scaleFactorCorrectedBySpeed)) + 1;
                let hasBgsNum = this.bgContainer.getAll().length;
                for (let i = hasBgsNum; i < requiredBgsNum; i++) {
                    this.bgContainer.add(this.add.image(0, i * (this.baseBGImageHeight - 2), 'texture-atlas', 'bg' + '0000').setOrigin(0.5, 0));
                }
            }
            restartTimer() {
                this.destroyTimer();
                this.timerEvent = this.time.addEvent({ delay: 1000, repeat: -1 });
                this.timerEvent.callback = () => {
                    this.timeLeft--;
                    this.ui.setTime(this.timeLeft);
                    if (this.timeLeft == 0) {
                        this.destroyTimer();
                        this.onTimeout();
                    }
                    else if (this.timeLeft <= this.timeAlert) {
                        this.ui.animateTimeIconScale(1000, 0, false);
                        uh.sound.SoundManager.getInstance().playSound('countdown_tick', 0.5, false);
                    }
                };
            }
            destroyTimer() {
                if (!this.timerEvent)
                    return;
                this.timerEvent.paused = true;
                this.timerEvent.destroy();
                this.timerEvent.callback = null;
            }
            sendScoreToServer(score) {
                let http = new XMLHttpRequest();
                let url = 'https://aftermarket.ctr.co.kr/api/Game';
                http.open('POST', url, true);
                http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
                http.onreadystatechange = function () {
                    console.log(http.responseText);
                    if (http.readyState == 4 && http.status == 200) {
                        console.log(http.responseText);
                    }
                };
                http.send(JSON.stringify({ "score": score }));
            }
            onTimeout() {
                if (this.score > uh.storage.LocalStorageController.instance.getBest()) {
                    let best = this.score;
                    uh.storage.LocalStorageController.instance.setBest(best);
                    this.ui.setBest(best);
                    this.sendScoreToServer(best);
                }
                this.isActivated = false;
                this.ui.showTimesUp(this.score, this.distance, this.onTryAgainClicked);
                uh.util.Functions.destroyDelayedCall(this.powerupsSpawner);
                this.powerupsSpawner = null;
                this.isPowerUpSpawnAllowed = true;
                uh.sound.SoundManager.getInstance().stopMusic();
                uh.sound.SoundManager.getInstance().playSound('defeat', 0.5);
            }
            calculateLineX(lineIndex) {
                return this.scale.width / 2 - ((this.totalCarLines / 2 - 0.5) - lineIndex) * this.carLineWidth * this.scaleFactor;
            }
            moveToLine(lineIndex) {
                if (this.carLineIndex == lineIndex)
                    return;
                this.carLineIndex = lineIndex;
                this.tweens.killTweensOf(this.car);
                let newLineX = this.calculateLineX(this.carLineIndex);
                this.isCarSwitchingLine = true;
                let duration = 375 - this.carSpeed / this.maxCarSpeed * 300;
                this.add.tween({
                    targets: this.car,
                    x: newLineX,
                    duration: duration * 0.9,
                    delay: duration * 0.1,
                    onComplete: () => {
                        this.isCarSwitchingLine = false;
                    },
                    ease: Phaser.Math.Easing.Sine.Out
                });
                let angle = 12 - this.carSpeed / this.maxCarSpeed * 6;
                this.add.tween({
                    targets: this.car,
                    angle: newLineX > this.car.x ? angle : -angle,
                    duration: duration / 2,
                    ease: Phaser.Math.Easing.Sine.Out,
                    onComplete: () => {
                        this.add.tween({
                            targets: this.car,
                            angle: 0,
                            duration: duration / 2,
                            ease: Phaser.Math.Easing.Sine.Out
                        });
                    }
                });
            }
            moveToSideCrash(right) {
                let toX = this.car.x + (right ? 1 : -1) * this.carLineWidth * 0.25 * this.scaleFactor;
                this.isCarSwitchingLine = true;
                let duration = (500 - this.carSpeed / this.maxCarSpeed * 250) / 2;
                let angle = 4 - this.carSpeed / this.maxCarSpeed * 2;
                this.add.tween({
                    targets: this.car,
                    x: toX,
                    angle: toX > this.car.x ? angle : -angle,
                    duration: duration / 2,
                    yoyo: true,
                    onComplete: () => {
                        this.isCarSwitchingLine = false;
                    }
                });
            }
            findClosestLine() {
                let minDx = Number.MAX_VALUE;
                let closestLine = -1;
                for (let i = 0; i < this.totalCarLines; i++) {
                    let _x = this.calculateLineX(i);
                    let dx = Math.abs(_x - this.car.x);
                    if (dx < minDx) {
                        minDx = dx;
                        closestLine = i;
                    }
                }
                this.carLineIndex = closestLine;
            }
            checkMovement() {
                // if (this.isCarSwitchingLine) return;
                let newCarLineIndex = this.carLineIndex;
                if (this.inputController.keyRightPressedDownAndReleased()) {
                    this.inputController.keyRightPressUsed();
                    if (this.carLineIndex < this.totalCarLines - 1) {
                        newCarLineIndex = this.carLineIndex + 1;
                    }
                }
                else if (this.inputController.keyLeftPressedDownAndReleased()) {
                    this.inputController.keyLeftPressUsed();
                    if (this.carLineIndex > 0) {
                        newCarLineIndex = this.carLineIndex - 1;
                    }
                }
                if (newCarLineIndex != this.carLineIndex) {
                    if (!this.checkObstaclesHit(newCarLineIndex)) {
                        this.moveToLine(newCarLineIndex);
                    }
                    else {
                        this.moveToSideCrash(newCarLineIndex > this.carLineIndex);
                    }
                }
            }
            calculateScaleFactor() {
                this.scaleFactor = 1;
                let artRatioHW = this.baseBGImageHeight / this.baseBGImageWidth;
                if (this.scale.width * artRatioHW > this.scale.height) {
                    this.scaleFactor = this.scale.height / this.baseBGImageHeight;
                }
                else {
                    this.scaleFactor = this.scale.width / this.baseBGImageWidth;
                }
                this.targetScaleFactorCorrectedBySpeed = this.scaleFactor;
                /*if (this.carSpeed > this.maxDefCarSpeed) {
                    this.targetScaleFactorCorrectedBySpeed *= this.maxDefCarSpeed / this.carSpeed;
                    this.targetScaleFactorCorrectedBySpeed = Math.pow(this.targetScaleFactorCorrectedBySpeed, 0.9);
                    if (this.targetScaleFactorCorrectedBySpeed > this.scaleFactor) this.targetScaleFactorCorrectedBySpeed = this.scaleFactor;
                }*/
                if (typeof this.scaleFactorCorrectedBySpeed == "undefined") {
                    this.scaleFactorCorrectedBySpeed = this.targetScaleFactorCorrectedBySpeed;
                }
                else {
                    this.scaleFactorCorrectedBySpeed += (this.targetScaleFactorCorrectedBySpeed - this.scaleFactorCorrectedBySpeed) / 10;
                }
            }
            resize() {
                let _carScale = this.car.frame.name == 'car0000' ? 1 : 2;
                this.bgContainer.setScale(this.scaleFactorCorrectedBySpeed);
                this.car.setScale(_carScale * this.scaleFactorCorrectedBySpeed);
                for (let i = this.obstacles.length - 1; i >= 0; i--) {
                    this.obstacles[i].setScale(this.scaleFactorCorrectedBySpeed, this.obstacles[i]["-scaleY-"] * this.scaleFactorCorrectedBySpeed);
                    this.obstacles[i].x = this.scale.width / 2;
                }
                for (let i = this.powerups.length - 1; i >= 0; i--) {
                    this.powerups[i].setScale(this.powerups[i].scale * this.scaleFactorCorrectedBySpeed);
                    this.powerups[i].x = this.calculateLineX(this.powerups[i]["line"]);
                }
                if (!this.isCarSwitchingLine || !this.isActivated) {
                    this.car.x = this.calculateLineX(this.carLineIndex);
                }
                this.car.y = this.scale.height - this.car.height * _carScale * this.scaleFactorCorrectedBySpeed;
                this.bgContainer.x = this.scale.width / 2;
            }
            updatePowerups() {
                for (let i = this.powerups.length - 1; i >= 0; i--) {
                    let powerUp = this.powerups[i];
                    powerUp.y += this.carSpeed * this.scaleFactorCorrectedBySpeed;
                    if (powerUp.y > this.scale.height + powerUp.height * this.scaleFactorCorrectedBySpeed) {
                        this.powerups.splice(i, 1);
                        this.tweens.killTweensOf(powerUp);
                        powerUp.destroy(true);
                    }
                }
                this.checkPowerupsCollect(this.carLineIndex);
            }
            checkPowerupsCollect(carLineIndex) {
                for (let i = this.powerups.length - 1; i >= 0; i--) {
                    let powerUp = this.powerups[i];
                    if (powerUp["line"] != carLineIndex)
                        continue;
                    if (powerUp.y < this.car.y)
                        continue;
                    if (powerUp.y > this.car.y + this.car.height * this.scaleFactorCorrectedBySpeed)
                        continue;
                    this.powerups.splice(i, 1);
                    powerUp.destroy(true);
                    this.onPowerupCollcted(powerUp);
                }
            }
            onPowerupCollcted(powerUp) {
                this.car.anims.play('car_powerup_playing')
                    .once('animationcomplete', () => { this.car.setFrame('car' + '0000'); });
                this.maxCarSpeed += this.carSpeedImpulseByPowerUp;
                this.carSpeed = this.maxCarSpeed;
                this.powerUpsCollected++;
                this.ui.setPowerUps(this.powerUpsCollected);
                this.calculateScore();
                this.ui.showBonusSecGained(powerUp.x, powerUp.y, 700, 100);
                let rnd = Math.ceil(Math.random() * 3);
                uh.sound.SoundManager.getInstance().playSound('ui-star-' + rnd, 0.5);
                uh.util.Functions.delayedCall(550, () => {
                    uh.sound.SoundManager.getInstance().playSound('star' + rnd, 0.5);
                });
                uh.sound.SoundManager.getInstance().playSound('Corvette4', 0.1);
            }
            spawnPowerUp(line = undefined, startY = 0) {
                if (!this.isPowerUpSpawnAllowed)
                    return;
                this.runPowerUpSpawner();
                let rnd = Math.random();
                let powerup = rnd < 0.25 ? "pu_logo" : rnd < 0.6 ? "pu_wheel" : "pu_ball";
                if (typeof line == "undefined") {
                    line = Math.floor(Math.random() * this.totalCarLines);
                }
                let powerUp = this.add.image(this.calculateLineX(line), startY, "texture-atlas", powerup + '0000');
                powerUp.y -= powerUp.height;
                powerUp.setOrigin(0.5, 0.5);
                powerUp["line"] = line;
                powerUp["powerup"] = powerup;
                powerUp.setDepth(2);
                this.powerups.push(powerUp);
                this.ingameContainer.add(powerUp);
                this.tweens.add({
                    targets: powerUp,
                    scale: 0.92,
                    duration: 500,
                    yoyo: true,
                    repeat: -1
                });
            }
            runPowerUpSpawner() {
                // this.isPowerUpSpawnAllowed = false;
                // this.powerupsSpawner = uh.util.Functions.delayedCall((0.5 + Math.random()*(1 - 0.5)) * 1000, ()=>{
                //     this.isPowerUpSpawnAllowed = true;
                // });
            }
            findLinesNotBlockingByObstacle(obstacleID) {
                let acceptableLines = [];
                for (let l = 0; l < this.totalCarLines; l++) {
                    if (this.obstaclesBlocks[obstacleID].indexOf(l) < 0) {
                        acceptableLines.push(l);
                    }
                }
                return acceptableLines.length > 0 ? Phaser.Utils.Array.GetRandom(acceptableLines) : 2;
            }
            findObstacleNotBlocking(lineIndex) {
                let acceptableObstacles = [];
                for (let obsId in this.obstaclesBlocks) {
                    if (this.obstaclesBlocks[obsId].indexOf(lineIndex) < 0) {
                        acceptableObstacles.push(obsId);
                    }
                }
                return acceptableObstacles.length > 0 ? Phaser.Utils.Array.GetRandom(acceptableObstacles) : 1;
            }
            findLineNotBlockedByObstacle(obstacle) {
                let acceptableLines = [];
                for (let line = 0; line < this.totalCarLines; line++) {
                    if (this.obstaclesBlocks[obstacle].indexOf(line) < 0) {
                        acceptableLines.push(line);
                    }
                }
                return acceptableLines.length > 0 ? Phaser.Utils.Array.GetRandom(acceptableLines) : 2;
            }
            randomizeBarrier() {
                let id = Phaser.Utils.Array.GetRandom(this.obstacleIDs);
                return id;
            }
            spawnObstacle() {
                let id = this.randomizeBarrier();
                let spawnAtLine = -1;
                if (id == 2) {
                    spawnAtLine = 1;
                }
                else if (id == 5) {
                    spawnAtLine = 3;
                }
                else if (id == 7) {
                    spawnAtLine = 2;
                }
                if (spawnAtLine == -1) {
                    spawnAtLine = this.findLineNotBlockedByObstacle(id);
                }
                this.spawnPowerUp(spawnAtLine);
                let _id = id;
                if (id == 5) {
                    _id = 2;
                }
                else if (id == 7) {
                    _id = 2;
                }
                else if (id == 10) {
                    _id = 9;
                }
                else if (id == 12) {
                    _id = 11;
                }
                let objectName = 'obstacle_' + _id;
                let obs = this.add.sprite(this.scale.width / 2, -400, "texture-atlas", objectName + '0000');
                obs["-scaleY-"] = 1;
                obs["id"] = id;
                obs.setDepth(1);
                this.obstacles.push(obs);
                if (id == 7) {
                    obs.setOrigin(0.3, 1);
                }
                else {
                    obs.setOrigin(0.5, 1);
                    if (_id != id) {
                        obs.flipX = true;
                    }
                }
                this.ingameContainer.addAt(obs, this.ingameContainer.getIndex(this.car));
                let animName = objectName + '_idle';
                this.anims.create({
                    key: animName,
                    frames: this.anims.generateFrameNames("texture-atlas", {
                        start: 0, end: 9, zeroPad: 4,
                        prefix: objectName, suffix: ''
                    }),
                    frameRate: 24,
                    repeat: -1
                });
                obs.anims.play(animName);
            }
            checkObstaclesHit(carLineIndex) {
                for (let i = this.obstacles.length - 1; i >= 0; i--) {
                    let obs = this.obstacles[i];
                    if (obs.y < this.car.y || obs.y > 0.95 * this.scale.height + obs.height * this.scaleFactorCorrectedBySpeed)
                        continue;
                    if (!obs["-alreadyHited-"] && this.obstaclesBlocks[obs["id"]].indexOf(carLineIndex) >= 0) {
                        obs["-alreadyHited-"] = true;
                        this.car.anims.play('car_hit_playing')
                            .once('animationcomplete', () => { this.car.setFrame('car' + '0000'); });
                        this.isCrashed = true;
                        this.carSpeed *= 0.25;
                        this.maxCarSpeed = this.maxDefCarSpeed;
                        this.add.tween({
                            targets: obs,
                            // "-scaleY-": 0,
                            "alpha": 0,
                            repeat: 4,
                            duration: 175,
                            onComplete: () => {
                                let ind = this.obstacles.indexOf(obs);
                                if (ind >= 0)
                                    this.obstacles.splice(ind, 1);
                                obs.destroy(true);
                                uh.util.Functions.delayedCall(950, () => {
                                    this.isCrashed = false;
                                });
                            }
                        });
                        let rnd = Math.ceil(Math.random() * 3);
                        uh.sound.SoundManager.getInstance().playSound('crash-' + rnd, 0.5);
                        this.cameras.main.shake(800, 0.005);
                        return true;
                    }
                }
                return false;
            }
            updateObstacles() {
                for (let i = this.obstacles.length - 1; i >= 0; i--) {
                    let obs = this.obstacles[i];
                    obs.y += this.carSpeed * this.scaleFactorCorrectedBySpeed;
                    if (obs.y > this.scale.height + obs.height * this.scaleFactorCorrectedBySpeed) {
                        this.obstacles.splice(i, 1);
                        obs.destroy(true);
                        this.maxCarSpeed += 1;
                    }
                }
                this.checkObstaclesHit(this.carLineIndex);
            }
            updateBG() {
                this.bgContainer.y += this.carSpeed * this.scaleFactorCorrectedBySpeed;
                if (this.bgContainer.y >= 0) {
                    this.bgContainer.y = -this.baseBGImageHeight * this.scaleFactorCorrectedBySpeed;
                }
            }
            resizeUI() {
                this.ui.resize(this.scaleFactor, (this.scale.width - this.baseBGImageWidth * this.scaleFactor) / 2, this.carLineWidth * this.scaleFactor / this.scale.width);
            }
            calculateScore() {
                this.score = Math.floor(this.distance / 0.01) + this.powerUpsCollected * 100;
                this.ui.setScore(this.score);
            }
            update() {
                this.calculateScaleFactor();
                this.resizeUI();
                if (this.isIngameShown) {
                    this.resize();
                    this.fillBgContainer();
                }
                if (!this.isActivated)
                    return;
                // if (!this.isCrashed) {
                this.ticker++;
                let carAccelerationFactor = this.carSpeed < this.maxCarSpeed * 0.5 ? this.carAccelerationFactor * 0.1 : this.carAccelerationFactor;
                this.carSpeed += (this.maxCarSpeed - this.carSpeed) / carAccelerationFactor;
                if (this.carSpeed > this.maxCarSpeed) {
                    this.carSpeed = this.maxCarSpeed;
                }
                this.distance += this.carSpeed / 10000;
                this.distance = Math.ceil(this.distance * 100) / 100;
                this.ui.setDistance(this.distance);
                this.calculateScore();
                if (this.ticker >= 70 - (this.carSpeed / this.maxCarSpeed * 25) /*Math.ceil(this.targetScaleFactorCorrectedBySpeed * 90)*/) {
                    if (Math.random() > 0.1 + 0.2 * this.targetScaleFactorCorrectedBySpeed) {
                        this.spawnObstacle();
                    }
                    else {
                        this.spawnPowerUp(Math.floor(Math.random() * this.totalCarLines));
                    }
                    this.ticker = 0;
                }
                this.checkMovement();
                this.updateBG();
                this.updateObstacles();
                this.updatePowerups();
                // }
            }
        }
        scene.ScreenMain = ScreenMain;
    })(scene = uh.scene || (uh.scene = {}));
})(uh || (uh = {}));
var uh;
(function (uh) {
    var sound;
    (function (sound) {
        class SoundManager {
            constructor(scene) {
                this.music = null;
                this.sounds = [];
                this.currentMusic = "";
                this.scene = scene;
            }
            static getInstance() {
                if (!SoundManager._instance) {
                    SoundManager._instance = new SoundManager(game.scene.getAt(0));
                }
                return SoundManager._instance;
            }
            playMusic(filename, loop = false, volume = 1) {
                if (this.currentMusic == filename) {
                    return;
                }
                this.stopMusic();
                this.music = this.scene.sound.add(filename);
                this.music["filename"] = filename;
                this.music.loop = loop;
                this.music.play();
                this.music.setVolume(volume);
                this.currentMusic = filename;
                return this.music;
            }
            stopMusic() {
                this.currentMusic = "";
                if (this.music)
                    this.music.stop();
            }
            setVolume(volume) {
                game.sound.volume = volume;
            }
            playSound(filename, volume = 1, loop = false) {
                let snd = filename;
                try {
                    let s = this.scene.sound.add(snd);
                    s["filename"] = filename;
                    s.loop = loop;
                    s.play();
                    s.setVolume(volume);
                    this.sounds.push(s);
                    return s;
                }
                catch (_a) {
                }
                return null;
            }
            stopSound() {
                for (let s of this.sounds)
                    s.stop();
            }
        }
        SoundManager._instance = null;
        sound.SoundManager = SoundManager;
    })(sound = uh.sound || (uh.sound = {}));
})(uh || (uh = {}));
var uh;
(function (uh) {
    var storage;
    (function (storage) {
        class LocalStorageController {
            constructor() {
                this.isLocalStorageSupported = false;
                this.name = "unseen-heroes-v2";
                this.data = null;
                this.data = {
                    "best": 0
                };
                this.checkLocalStorageSupported();
                this.createOrLoad();
            }
            static get instance() {
                if (!LocalStorageController._instance) {
                    LocalStorageController._instance = new LocalStorageController();
                }
                return LocalStorageController._instance;
            }
            ;
            flush() {
                if (!this.isLocalStorageSupported)
                    return;
                localStorage[this.name] = JSON.stringify(this.data);
            }
            createOrLoad() {
                if (!this.isLocalStorageSupported)
                    return;
                if (localStorage[this.name]) { //localStorage exist
                    this.data = JSON.parse(localStorage[this.name]);
                }
                else {
                    this.flush();
                }
            }
            checkLocalStorageSupported() {
                try {
                    this.isLocalStorageSupported = "localStorage" in window && window["localStorage"] !== null;
                }
                catch (e) {
                    this.isLocalStorageSupported = false;
                }
            }
            getBest() {
                return this.data["best"];
            }
            setBest(best) {
                this.data["best"] = best;
                this.flush();
            }
        }
        LocalStorageController._instance = null;
        storage.LocalStorageController = LocalStorageController;
    })(storage = uh.storage || (uh.storage = {}));
})(uh || (uh = {}));
var uh;
(function (uh) {
    var ui;
    (function (ui) {
        class UI extends Phaser.GameObjects.Container {
            constructor(parent) {
                super(parent);
                this.timesupPopup = null;
                this.howFarMessage = null;
                this.icon_123 = null;
                this.isTitleScreenShown = false;
                this.currentTime = -1;
                this.score = this.scene.add.dom(0, 0, document.createElement('div'));
                this.score.node["style"].display = "none";
                this.score.skewX = -0.4;
                this.score.angle = -8;
                this.add(this.score);
                this.setScore(19);
                this.score["-scale-"] = 1;
                this.best = this.scene.add.dom(0, 0, document.createElement('div'));
                this.best.node["style"].display = "none";
                this.best.skewX = -0.4;
                this.best.angle = -8;
                this.add(this.best);
                this.setBest(747569);
                this.distance = this.scene.add.dom(0, 0, document.createElement('div'));
                this.distance.node["style"].display = "none";
                this.distance.skewX = -0.4;
                this.add(this.distance);
                this.setDistance(10.9);
                this.powerUps = this.scene.add.dom(0, 0, document.createElement('div'));
                this.powerUps.node["style"].display = "none";
                this.powerUps.skewX = -0.4;
                this.add(this.powerUps);
                this.setPowerUps(2);
                this.time = this.scene.add.dom(0, 0, document.createElement('div'));
                this.time.node["style"].display = "none";
                this.time.skewX = -0.4;
                this.time.angle = -8;
                this.time["-scale-"] = 1;
                this.add(this.time);
                this.setTime(17);
                this.clickToPlay = this.scene.add.dom(0, 0, document.createElement('div'));
                this.clickToPlay.node["style"].display = "none";
                this.clickToPlay.skewX = -0.4;
                this.add(this.clickToPlay);
                this.clickToPlay.node.innerHTML = '<span style="font: 40px Lo-Res; color: #FFFFFF; cursor:default; vertical-align: middle;display: flex;justify-content: center;flex-direction: column;text-align: center;">CLICK TO PLAY</span>';
                this.copyrightEtc = this.scene.add.dom(0, 0, document.createElement('div'));
                this.copyrightEtc.node["style"].display = "none";
                this.add(this.copyrightEtc);
                this.copyrightEtc.node.innerHTML = '<span style="font: 20px Lo-Res; color: #FFFFFF; cursor:default; vertical-align: middle;display: flex;justify-content: center;flex-direction: column;text-align: center;">ⓒ 2021 CENTRAL CORPORATION COPYRIGHT. ALL RIGHTS RESERVED.</span>';
                this.popup_icons = this.scene.add.image(0, 0, 'texture-atlas', 'popup_icons' + '0000');
                this.popup_icons.setOrigin(1, 0.5);
                this.add(this.popup_icons);
                this.titleScreenObstacle_Right = this.scene.add.image(0, 0, 'texture-atlas', 'titleScreenObstacle' + '0000');
                this.titleScreenObstacle_Right.setOrigin(0.5, 0.5);
                this.titleScreenObstacle_Right.flipX = true;
                this.add(this.titleScreenObstacle_Right);
                this.titleScreenObstacle_Left = this.scene.add.image(0, 0, 'texture-atlas', 'titleScreenObstacle' + '0000');
                this.titleScreenObstacle_Left.setOrigin(0.5, 0.5);
                this.add(this.titleScreenObstacle_Left);
                this.uh_logo = this.scene.add.image(0, 0, 'texture-atlas', 'uh_logo' + '0000');
                this.uh_logo.setOrigin(0.5, 0.5);
                this.add(this.uh_logo);
                this.ctr_logo = this.scene.add.image(0, 0, 'texture-atlas', 'ctr_logo' + '0000');
                this.ctr_logo.setOrigin(0.5, 0.5);
                this.add(this.ctr_logo);
                window["ui"] = this;
            }
            showTimesUp(score, distance, onTryAgainClicked) {
                this.timesupPopup = this.scene.add.container(0, 0);
                this.add(this.timesupPopup);
                this.timesupPopup["-scale-"] = 1.5;
                this.timesupPopup.alpha = 0;
                this.scene.tweens.add({
                    targets: this.timesupPopup,
                    "-scale-": 1,
                    alpha: 1,
                    duration: 500
                });
                let timesup_popup = this.scene.add.image(0, 0, 'texture-atlas', 'timesup_popup' + '0000');
                timesup_popup.setOrigin(0.5, 0.5);
                this.timesupPopup.add(timesup_popup);
                let onDownAnim = (btn) => {
                    btn.scale = 1;
                    this.scene.tweens.add({
                        targets: btn,
                        scale: 0.9,
                        yoyo: true,
                        duration: 150
                    });
                };
                let btn_tryagain = this.scene.add.image(0, (105 - 49) * uh.App.ART_SCALE, 'texture-atlas', 'btn_tryagain' + '0000');
                btn_tryagain.setOrigin(0.5, 0.5);
                btn_tryagain.setInteractive({ cursor: "pointer" });
                this.timesupPopup.add(btn_tryagain);
                btn_tryagain.once('pointerdown', () => {
                    onDownAnim(btn_tryagain);
                    onTryAgainClicked();
                });
                let btn_learnmore = this.scene.add.image(0, (208 - 49) * uh.App.ART_SCALE, 'texture-atlas', 'btn_learnmore' + '0000');
                btn_learnmore.setOrigin(0.5, 0.5);
                btn_learnmore.setInteractive({ cursor: "pointer" });
                this.timesupPopup.add(btn_learnmore);
                btn_learnmore.on('pointerdown', () => {
                    onDownAnim(btn_learnmore);
                    window.open("https://aftermarket.ctr.co.kr/UnseenHeroes", "_blank");
                });
                let btn_fbshare = this.scene.add.image(0, (311 - 49) * uh.App.ART_SCALE, 'texture-atlas', 'btn_fbshare' + '0000');
                btn_fbshare.setOrigin(0.5, 0.5);
                btn_fbshare.setInteractive({ cursor: "pointer" });
                this.timesupPopup.add(btn_fbshare);
                btn_fbshare.on('pointerdown', () => {
                    onDownAnim(btn_fbshare);
                    let quote = "CTR is calling all Unseen Heroes! I just got a high score of " + score + "! Got what it takes to beat my high score?";
                    window.open("https://www.facebook.com/sharer/sharer.php?" +
                        "kid_directed_site=0" +
                        "&sdk=joey" +
                        "&u=" + "https://aftermarket.ctr.co.kr/game/" +
                        "&display=popup" +
                        "&ref=plugin" +
                        "&quote=" + quote +
                        "&src=share_button", "sharerPopUp", "height=400,width=400");
                });
                let btn_ss = this.scene.add.image(0, 365 * uh.App.ART_SCALE, 'texture-atlas', 'btn_ss' + '0000');
                btn_ss.setOrigin(0.5, 0.5);
                this.timesupPopup.add(btn_ss);
                let timesupPopupScoredTF = this.scene.add.text(0, -150 * uh.App.ART_SCALE, String(score), {
                    "fontFamily": "Lo-Res",
                    "fontSize": 160 * uh.App.ART_SCALE,
                    "color": "#FFFFFF",
                    "align": 'center'
                });
                timesupPopupScoredTF.setOrigin(0.5, 0.5);
                this.timesupPopup.add(timesupPopupScoredTF);
                let timesupPopupDistanceTF = this.scene.add.text(-55 * uh.App.ART_SCALE, -34 * uh.App.ART_SCALE, distance + ' KM', {
                    "fontFamily": "Lo-Res",
                    "fontSize": 60 * uh.App.ART_SCALE,
                    "color": "#FFFFFF",
                    "align": 'center'
                });
                timesupPopupDistanceTF.setOrigin(0, 0.5);
                this.timesupPopup.add(timesupPopupDistanceTF);
            }
            hideTimesUp() {
                this.remove(this.timesupPopup, true);
                this.timesupPopup = null;
            }
            showBonusSecGained(x, y, totalAnimDuration, bonus) {
                let tf = this.scene.add.text(x, y, "+" + String(bonus), {
                    "fontFamily": "Lo-Res",
                    "fontSize": 40,
                    "color": "#FFFFFF",
                    "align": 'center'
                });
                tf.setOrigin(0.5, 1);
                this.add(tf);
                this.scene.tweens.add({
                    targets: tf,
                    alpha: 0,
                    duration: totalAnimDuration * 1.05,
                    ease: Phaser.Math.Easing.Circular.In
                });
                this.scene.tweens.add({
                    targets: tf,
                    x: this.score.x,
                    y: this.score.y,
                    duration: totalAnimDuration,
                    ease: Phaser.Math.Easing.Circular.In,
                    onComplete: () => {
                        tf.destroy(true);
                        this.animateScoreIconScale();
                    }
                });
            }
            animateScoreIconScale() {
                this.scene.tweens.killTweensOf(this.score);
                this.score["-scale-"] = 1;
                this.scene.tweens.add({
                    targets: this.score,
                    "-scale-": 1.35,
                    duration: 200,
                    yoyo: true
                });
            }
            animateTimeIconScale(duration, repeat = 0, yoyo = true) {
                this.scene.tweens.killTweensOf(this.time);
                this.time["-scale-"] = 1;
                this.time["alpha"] = 1;
                this.scene.tweens.add({
                    targets: this.time,
                    "-scale-": 1.25,
                    "alpha": 0.15,
                    duration: duration,
                    yoyo: yoyo,
                    repeat: repeat,
                    onComplete: () => {
                        this.time["alpha"] = 1;
                    }
                });
            }
            showHowFarMessage() {
                this.howFarMessage = this.scene.add.image(0, 0, 'texture-atlas', 'hf_message' + '0000');
                this.howFarMessage.setOrigin(0.48, 0.5);
                this.add(this.howFarMessage);
            }
            hideHowFarMessage() {
                this.remove(this.howFarMessage, true);
                this.howFarMessage = null;
            }
            showIcon321(onComplete) {
                let animate = (frame) => {
                    this.icon_123.setFrame(frame);
                    this.icon_123.alpha = 0;
                    this.icon_123["-scale-"] = 1.5;
                    this.scene.tweens.add({
                        targets: this.icon_123,
                        "-scale-": 1,
                        alpha: 1,
                        duration: 500
                    });
                };
                this.icon_123 = this.scene.add.image(0, 0, "texture-atlas", 'countdown_3' + '0000');
                this.add(this.icon_123);
                this.icon_123["-scale-"] = 1;
                animate('countdown_3' + '0000');
                uh.util.Functions.delayedCall(1000, () => {
                    animate('countdown_2' + '0000');
                    uh.util.Functions.delayedCall(1000, () => {
                        animate('countdown_1' + '0000');
                        uh.util.Functions.delayedCall(900, () => {
                            animate('countdown_go' + '0000');
                            uh.util.Functions.delayedCall(1000, () => {
                                this.icon_123.destroy(true);
                                this.icon_123 = null;
                                onComplete();
                            });
                        });
                    });
                });
                uh.sound.SoundManager.getInstance().playSound('321go', 0.25);
            }
            showTitleScreen() {
                this.isTitleScreenShown = true;
                this.showHowFarMessage();
            }
            hideTitleScreen() {
                this.isTitleScreenShown = false;
                this.hideHowFarMessage();
            }
            setScore(score) {
                this.score.node.innerHTML = '<span style="font: 50px Noto Sans Bold; color: #FFFFFF; cursor:default; vertical-align: middle;">SCORE&nbsp;&nbsp;&nbsp;</span><span style="font: 50px Lo-Res; color: #FFFFFF; cursor:default; vertical-align: middle;">' + uh.util.Functions.padBack(score, 10, '&nbsp;') + '</span>';
            }
            setBest(best) {
                this.best.node.innerHTML = '<span style="font: 50px Noto Sans Bold; color: #FFFFFF; cursor:default; vertical-align: middle;">BEST&nbsp;&nbsp;&nbsp;</span><span style="font: 50px Lo-Res; color: #FFFFFF; cursor:default; vertical-align: middle;">' + uh.util.Functions.padBack(best, 10, '&nbsp;') + '</span>';
            }
            setDistance(distance) {
                this.distance.node.innerHTML = '<span style="font: 50px Noto Sans Bold; color: #FFFFFF; cursor:default; vertical-align: middle;">DISTANCE&nbsp;&nbsp;&nbsp;</span><span style="font: 50px Lo-Res; color: #FFFFFF; cursor:default; vertical-align: middle;">'
                    + uh.util.Functions.padBack(distance.toFixed(2) + '&nbsp;KM', 10, '&nbsp;')
                    + '</span>';
            }
            setPowerUps(xNum) {
                this.powerUps.node.innerHTML = '<span style="font: 50px Lo-Res; color: #FFFFFF; cursor:default; vertical-align: middle;">&nbsp;' + uh.util.Functions.padBack(xNum, 15, '&nbsp;') + '</span>';
            }
            setTime(seconds) {
                this.currentTime = seconds;
                this.time.node.innerHTML = '<span style="font: 100px Noto Sans Bold; color: #FF0000; cursor:default; vertical-align: middle;-webkit-text-stroke: 2px black;line-height:0px;">'
                    + (seconds == 0 ? 'TIME\'S' : 'TIME')
                    + '<br/></span><span style="font: 240px Noto Sans Bold; color: #FFFFFF; cursor:default; vertical-align: middle;-webkit-text-stroke: 4px black;">'
                    + (seconds == 0 ? 'UP!' : uh.util.Functions.pad(seconds, 2, 0))
                    + '</span>';
            }
            resize(scaleFactor, sideRectWidths, timeWidthPercentage) {
                let sidePercentage = sideRectWidths / this.scene.scale.width;
                let landscapeMode = sidePercentage > 0.25;
                if (this.isTitleScreenShown) {
                    this.score.visible = this.best.visible = this.distance.visible = this.powerUps.visible = this.time.visible = this.popup_icons.visible = false;
                    this.uh_logo.visible = this.ctr_logo.visible = true;
                    this.clickToPlay.visible = this.copyrightEtc.visible = this.titleScreenObstacle_Right.visible = this.titleScreenObstacle_Left.visible = true;
                    if (landscapeMode) {
                        let superWidthScaleFactor = sidePercentage > 0.4 ? Math.pow(1 - sidePercentage, 2) : 1;
                        this.uh_logo.setScale(this.scene.scale.width * 0.45 / this.uh_logo.width * superWidthScaleFactor);
                        this.ctr_logo.setScale(this.scene.scale.width * 0.15 / this.ctr_logo.width * superWidthScaleFactor);
                        this.titleScreenObstacle_Right.setScale(this.scene.scale.width * 0.4 / this.titleScreenObstacle_Right.width * superWidthScaleFactor);
                        this.titleScreenObstacle_Left.setScale(this.scene.scale.width * 0.4 / this.titleScreenObstacle_Left.width * superWidthScaleFactor);
                        this.clickToPlay.setScale(this.scene.scale.width * 0.2 / this.clickToPlay.node.clientWidth * superWidthScaleFactor);
                        this.copyrightEtc.setScale(this.scene.scale.width * 0.25 / this.copyrightEtc.node.clientWidth * superWidthScaleFactor);
                        this.howFarMessage.setScale(this.scene.scale.width * 0.33 / this.howFarMessage.width * superWidthScaleFactor);
                        this.uh_logo.setPosition(this.scene.scale.width * 0.5, this.scene.scale.height * 0.4);
                        this.howFarMessage.setPosition(this.scene.scale.width / 2, this.scene.scale.height * 0.79);
                        this.clickToPlay.setPosition(this.scene.scale.width * 0.5 - (this.clickToPlay.node.clientWidth * this.clickToPlay.scaleX * 0.5), this.scene.scale.height * 0.88);
                        this.copyrightEtc.setPosition(this.scene.scale.width * 0.5 - (this.copyrightEtc.node.clientWidth * this.copyrightEtc.scaleX * 0.5), this.scene.scale.height * 0.96);
                    }
                    else {
                        this.uh_logo.setScale(this.scene.scale.width * 0.6 / this.uh_logo.width);
                        this.ctr_logo.setScale(this.scene.scale.width * 0.25 / this.ctr_logo.width);
                        this.titleScreenObstacle_Right.setScale(this.scene.scale.width * 0.3 / this.titleScreenObstacle_Right.width);
                        this.titleScreenObstacle_Left.setScale(this.scene.scale.width * 0.3 / this.titleScreenObstacle_Left.width);
                        this.clickToPlay.setScale(this.scene.scale.width * 0.3 / this.clickToPlay.node.clientWidth);
                        this.copyrightEtc.setScale(this.scene.scale.width * 0.35 / this.copyrightEtc.node.clientWidth);
                        this.howFarMessage.setScale(this.scene.scale.width * 0.9 / this.howFarMessage.width);
                        this.uh_logo.setPosition(this.scene.scale.width * 0.5, this.scene.scale.height * 0.5);
                        this.howFarMessage.setPosition(this.scene.scale.width / 2, this.scene.scale.height * 0.75);
                        this.clickToPlay.setPosition(this.scene.scale.width * 0.5 - (this.clickToPlay.node.clientWidth * this.clickToPlay.scaleX * 0.5), this.scene.scale.height * 0.83);
                        this.copyrightEtc.setPosition(this.scene.scale.width * 0.5 - (this.copyrightEtc.node.clientWidth * this.copyrightEtc.scaleX * 0.5), this.scene.scale.height * 0.93);
                    }
                    this.ctr_logo.setPosition(this.scene.scale.width * 0.5, this.scene.scale.height * 0.05 + this.ctr_logo.height * this.ctr_logo.scaleY * 0.5);
                    this.titleScreenObstacle_Right.setPosition(this.scene.scale.width, this.scene.scale.height * 0.5);
                    this.titleScreenObstacle_Left.setPosition(0, this.scene.scale.height * 0.5);
                    return;
                }
                this.clickToPlay.visible = this.copyrightEtc.visible = this.titleScreenObstacle_Right.visible = this.titleScreenObstacle_Left.visible = false;
                this.score.visible = this.best.visible = this.distance.visible = this.powerUps.visible = this.time.visible = this.popup_icons.visible = true;
                let attentionUpScale = this.currentTime <= 5 ? 1.25 : 1;
                this.time.setScale(this.time["-scale-"] * this.scene.scale.width * timeWidthPercentage / this.time.node.clientWidth * attentionUpScale);
                if (landscapeMode) {
                    this.distance.angle = 0;
                    let coefficient = Math.pow(1 - sidePercentage, 2.5);
                    this.score.setScale(this.score["-scale-"] * (sideRectWidths * coefficient / this.score.node.clientWidth));
                    this.best.setScale(sideRectWidths * coefficient / this.best.node.clientWidth);
                    this.distance.setScale(sideRectWidths * coefficient / this.distance.node.clientWidth);
                    this.powerUps.setScale(sideRectWidths * coefficient / this.powerUps.node.clientWidth);
                    this.uh_logo.setScale(sideRectWidths * 0.65 / this.uh_logo.width);
                    this.ctr_logo.setScale(sideRectWidths * 0.5 / this.ctr_logo.width);
                    this.popup_icons.setScale(sideRectWidths * 0.3 / this.popup_icons.width);
                    this.time.setPosition(this.scene.scale.width / 2 - (this.time.node.clientWidth * this.time.scaleX * 0.35), this.scene.scale.height * 0.05);
                    this.score.setPosition(sideRectWidths * 0.5 - (this.score.node.clientWidth * this.score.scaleX * 0.5), this.scene.scale.height * 0.05);
                    this.best.setPosition(this.scene.scale.width - sideRectWidths * 0.5 - (this.best.node.clientWidth * this.best.scaleX * 0.5), this.scene.scale.height * 0.05);
                    this.distance.setPosition(sideRectWidths * 0.5 - (this.distance.node.clientWidth * this.distance.scaleX * 0.5), this.scene.scale.height * 0.95 - (this.distance.node.clientHeight * this.distance.scaleY * 0.5));
                    this.powerUps.setPosition(this.scene.scale.width - sideRectWidths * 0.45, this.scene.scale.height * 0.95 - (this.powerUps.node.clientHeight * this.powerUps.scaleY * 0.5));
                    this.uh_logo.visible = this.ctr_logo.visible = this.popup_icons.visible = this.powerUps.visible = true;
                    this.uh_logo.setPosition(sideRectWidths * 0.5, this.scene.scale.height * 0.5);
                    this.ctr_logo.setPosition(this.scene.scale.width - sideRectWidths * 0.5, this.scene.scale.height * 0.5);
                    this.popup_icons.setPosition(this.scene.scale.width - sideRectWidths * 0.5, this.scene.scale.height * 0.95);
                }
                else {
                    this.distance.angle = -8;
                    this.score.setScale(this.score["-scale-"] * (this.scene.scale.width * 0.4 / this.score.node.clientWidth));
                    this.best.setScale(this.scene.scale.width * 0.4 / this.best.node.clientWidth);
                    this.distance.setScale(this.scene.scale.width * 0.4 / this.distance.node.clientWidth);
                    this.time.setPosition(this.scene.scale.width * 0.95 - (this.time.node.clientWidth * this.time.scaleX), this.scene.scale.height * 0.05);
                    this.score.setPosition(this.scene.scale.width * 0.1, this.scene.scale.height * 0.035);
                    this.best.setPosition(this.scene.scale.width * 0.1, this.scene.scale.height * 0.085);
                    this.distance.setPosition(this.scene.scale.width * 0.1, this.scene.scale.height * 0.135);
                    this.uh_logo.visible = this.ctr_logo.visible = this.popup_icons.visible = this.powerUps.visible = false;
                }
                if (this.timesupPopup) {
                    this.timesupPopup.setScale(this.timesupPopup["-scale-"] * scaleFactor);
                    this.timesupPopup.setPosition(this.scene.scale.width / 2, this.scene.scale.height / 2);
                }
                if (this.icon_123) {
                    this.icon_123.setScale(this.icon_123["-scale-"] * scaleFactor);
                    this.icon_123.setPosition(this.scene.scale.width / 2, this.scene.scale.height / 2);
                }
            }
        }
        ui.UI = UI;
    })(ui = uh.ui || (uh.ui = {}));
})(uh || (uh = {}));
var uh;
(function (uh) {
    var util;
    (function (util) {
        class Functions {
            static delayedCall(delay, callback, args, callbackScope) {
                let scene = game.scene.getAt(0);
                if (scene) {
                    let dc = scene.time.delayedCall(delay, callback, args, callbackScope);
                    Functions.delayedCalls.push(dc);
                    return dc;
                }
                let t = setTimeout(callback, delay);
                Functions.delayedCalls.push(t);
                return t;
            }
            static pauseAllDelayedCalls() {
                for (let dc of Functions.delayedCalls) {
                    if (dc instanceof Phaser.Time.TimerEvent) {
                        dc.paused = true;
                    }
                }
            }
            static resumeAllDelayedCalls() {
                for (let dc of Functions.delayedCalls) {
                    if (dc instanceof Phaser.Time.TimerEvent) {
                        dc.paused = false;
                    }
                }
            }
            static destroyAllDelayedCalls() {
                for (let dc of Functions.delayedCalls) {
                    if (dc instanceof Phaser.Time.TimerEvent) {
                        dc.remove(false);
                    }
                    else {
                        clearTimeout(dc);
                    }
                }
                Functions.delayedCalls = [];
            }
            static destroyDelayedCall(dc) {
                let ind = Functions.delayedCalls.indexOf(dc);
                if (ind >= 0) {
                    Functions.delayedCalls.splice(ind, 1);
                }
                if (dc instanceof Phaser.Time.TimerEvent) {
                    dc.remove(false);
                }
                else {
                    clearTimeout(dc);
                }
            }
            static pad(n, width, z) {
                z = z || '0';
                n = n + '';
                return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
            }
            ;
            static padBack(n, width, z) {
                z = z || '0';
                n = n + '';
                return n.length >= width ? n : n + new Array(width - n.length + 1).join(z);
            }
            ;
            static toGlobal(object, point) {
                let pos = point ? { x: point.x, y: point.y } : { x: 0, y: 0 };
                let parentContainer = object;
                while (parentContainer) {
                    pos.x *= parentContainer.scaleX;
                    pos.y *= parentContainer.scaleY;
                    pos.x += parentContainer.x;
                    pos.y += parentContainer.y;
                    parentContainer = parentContainer.parentContainer;
                }
                return pos;
            }
            static toLocal(object, point) {
                let path = [];
                let parentContainer = object;
                while (parentContainer) {
                    path.push(parentContainer);
                    parentContainer = parentContainer.parentContainer;
                }
                let pos = { x: point.x, y: point.y };
                let p = path.pop();
                do {
                    pos.x -= p.x;
                    pos.y -= p.y;
                    pos.x /= p.scaleX;
                    pos.y /= p.scaleY;
                    if (path.length > 0) {
                        p = path.pop();
                    }
                    else {
                        break;
                    }
                } while (true);
                return pos;
            }
        }
        Functions.delayedCalls = [];
        util.Functions = Functions;
    })(util = uh.util || (uh.util = {}));
})(uh || (uh = {}));
